"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const comapny_service_1 = require("./comapny.service");
const comapny_swagger_1 = require("./comapny.swagger");
const company_detail_dto_1 = require("./dto/company-detail.dto");
const create_company_dto_1 = require("./dto/create-company.dto");
const get_company_list_dto_1 = require("./dto/get-company-list-dto");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const update_company_dto_1 = require("./dto/update-company.dto");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let CompanyController = class CompanyController {
    constructor(companyService, scopeService) {
        this.companyService = companyService;
        this.scopeService = scopeService;
    }
    // Create a new company
    async createCompany(companyDto, companyDetailsDto, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            companyDto.countryId = await this.companyService.getCountryId(userId);
            companyDto.currencyId = await this.companyService.getCurrencyId(companyDto.countryId);
            companyDto.createdBy = userId;
            companyDto.updatedBy = userId;
            const companyData = await this.companyService.createCompany(companyDto, companyDetailsDto, userId);
            return res
                .status(common_1.HttpStatus.CREATED)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, messages_1.successMessage.companyCreated, companyData));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.companyNotFound, messages_1.errorMessages.companyCreationForbidden, messages_1.errorMessages.companyCreationFailed);
        }
    }
    // Get a list of companies
    // with pagination, search, and sorting options.
    async getCompanyList(query, res, req) {
        try {
            const { page, limit, search, entityIds } = query;
            const userId = parseInt(req?.headers?.userid);
            const companyList = await this.companyService.getCompanyList(page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, search || "", userId, entityIds);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.companyListRetrieved, companyList));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error.message || messages_1.errorMessages.companyListNotFound));
        }
    }
    async getCompaniesData(query, res, req) {
        try {
            const { page, limit, search } = query;
            const userId = parseInt(req?.headers?.userid);
            const companyData = await this.companyService.getCompanies(page, limit, userId, search);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.companyListRetrieved, companyData));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error.message || messages_1.errorMessages.companyListNotFound));
        }
    }
    // Get a list of group companies with pagination and search.
    async getGroupCompanies(query, res, req) {
        try {
            const { page, limit, search } = query;
            const userId = parseInt(req?.headers?.userid);
            const companyList = await this.companyService.getGroupCompanies(page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, search || "", userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.groupCompanyListRetrieved, companyList));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error.message || messages_1.errorMessages.groupCompanyListRetrievalFailed));
        }
    }
    // Get a company by its ID
    async getCompanyById(id, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "company", "view", parseInt(id));
            if (!viewValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to view this company.");
            }
            const companyData = await this.companyService.getCompanyById(id, userId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.companyDetails, companyData);
        }
        catch (error) {
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error instanceof Error ? error.message : messages_1.errorMessages.companyNotFound);
        }
    }
    // List companies
    async getCompanies(query, res, req) {
        try {
            const { page, limit, search, sort, searchBy } = query;
            const userId = parseInt(req?.headers?.userid);
            const companies = await this.companyService.listCompanies(page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, search || "", sort || "createdAt:DESC", userId, searchBy || "");
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.companyListRetrieved, companies));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.companyListNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.companyListRetrievalFailed);
        }
    }
    // Update a company by its companyId
    async updateCompany(companyId, companyDto, companyDetailsDto, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "company", "edit", parseInt(companyId));
            if (!viewValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company.");
            }
            companyDto.updatedBy = userId;
            const updatedCompany = await this.companyService.updateCompany(companyId, companyDto, companyDetailsDto);
            if (!updatedCompany) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.companyNotFound));
            }
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.companyUpdated, updatedCompany));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.companyNotFound, messages_1.errorMessages.companyUpdateForbidden, messages_1.errorMessages.companyUpdateFailed);
        }
    }
    async getCompanyBasicDetails(id, req, contactId) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "company", "view", parseInt(id));
            if (!viewValidation) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to view this company.");
            }
            const companyData = await this.companyService.getCompanyBasicDetails(parseInt(id), userId, contactId);
            return (0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.companyDetails, companyData);
        }
        catch (error) {
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error instanceof Error ? error.message : messages_1.errorMessages.companyNotFound);
        }
    }
};
exports.CompanyController = CompanyController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, comapny_swagger_1.createCompanySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)("company")),
    tslib_1.__param(1, (0, common_1.Body)("companyDetails")),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__param(3, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof create_company_dto_1.CreateCompanyDto !== "undefined" && create_company_dto_1.CreateCompanyDto) === "function" ? _c : Object, typeof (_d = typeof company_detail_dto_1.CompanyDetailsDto !== "undefined" && company_detail_dto_1.CompanyDetailsDto) === "function" ? _d : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CompanyController.prototype, "createCompany", null);
tslib_1.__decorate([
    (0, common_1.Get)("companyList"),
    (0, comapny_swagger_1.getCompanyListSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_e = typeof get_company_list_dto_1.GetCompanyListDto !== "undefined" && get_company_list_dto_1.GetCompanyListDto) === "function" ? _e : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CompanyController.prototype, "getCompanyList", null);
tslib_1.__decorate([
    (0, common_1.Get)("company-hierarchy"),
    (0, comapny_swagger_1.getCompaniesDataSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_f = typeof get_company_list_dto_1.GetCompanyListDto !== "undefined" && get_company_list_dto_1.GetCompanyListDto) === "function" ? _f : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CompanyController.prototype, "getCompaniesData", null);
tslib_1.__decorate([
    (0, common_1.Get)("group-company"),
    (0, comapny_swagger_1.getGroupCompaniesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_g = typeof get_company_list_dto_1.GetCompanyListDto !== "undefined" && get_company_list_dto_1.GetCompanyListDto) === "function" ? _g : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CompanyController.prototype, "getGroupCompanies", null);
tslib_1.__decorate([
    (0, common_1.Get)(":id"),
    (0, comapny_swagger_1.getCompanySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CompanyController.prototype, "getCompanyById", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, comapny_swagger_1.getCompaniesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_h = typeof get_company_list_dto_1.GetCompaniesDto !== "undefined" && get_company_list_dto_1.GetCompaniesDto) === "function" ? _h : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CompanyController.prototype, "getCompanies", null);
tslib_1.__decorate([
    (0, common_1.Put)(":companyId"),
    (0, comapny_swagger_1.updateCompanySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("companyId")),
    tslib_1.__param(1, (0, common_1.Body)("company")),
    tslib_1.__param(2, (0, common_1.Body)("companyDetails")),
    tslib_1.__param(3, (0, common_1.Res)()),
    tslib_1.__param(4, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_j = typeof update_company_dto_1.UpdateCompanyDto !== "undefined" && update_company_dto_1.UpdateCompanyDto) === "function" ? _j : Object, typeof (_k = typeof company_detail_dto_1.CompanyDetailsDto !== "undefined" && company_detail_dto_1.CompanyDetailsDto) === "function" ? _k : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CompanyController.prototype, "updateCompany", null);
tslib_1.__decorate([
    (0, common_1.Get)("details/:id"),
    (0, comapny_swagger_1.getCompanyDetailsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Query)("contactId")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], CompanyController.prototype, "getCompanyBasicDetails", null);
exports.CompanyController = CompanyController = tslib_1.__decorate([
    (0, common_1.Controller)("company"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof comapny_service_1.CompanyService !== "undefined" && comapny_service_1.CompanyService) === "function" ? _a : Object, typeof (_b = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _b : Object])
], CompanyController);
